<template>
  <div class="simple-header-container">
    <!-- <div>Menu</div> -->
    <div class="display-flex-center">
      <!-- <div class="home-nav__icon-wrapper">
        <MainLogo class="home-logo"></MainLogo>
      </div> -->
      <!--  class="home-nav__container" -->
      <div class="header-menu__container">
        <router-link
          :to="{ name: o.pathName }"
          class="home-menu__child relative"
          :class="{
            selected: o.selected || manualHighlightMenu(o),
            'font-l': currentLocale === 'th',
          }"
          v-for="(o, index) in simpleHeader"
          :key="index"
        >
          <span>{{ $t(o.name) }}</span>
          <div class="home-menu__child-indicator"></div>
          <!-- <div v-if="o.isLive" class="dot-wrapper">
            <div class="ripple"></div>
          </div> -->
        </router-link>
        <!-- <router-link :to="`/${currentLocale}/highlights`" class="home-nav__child"><span>Highlights</span><div class="home-nav__child-indicator"></div></router-link> -->
      </div>
    </div>
    
    <!-- Language Selection -->
    <div
      class="language-wrapper"
      @mouseenter="handleShowLanguageList('enter')"
      @mouseleave="handleShowLanguageList('leave')"
    >
      <!-- <div class="langauge-selection__wrapper">
        <div class="langauge-selection"  @click="handleShowLanguageList('click')">
        <img class="img-contain"  :src="require(`../../static/images/flags/${currentLanguageObj.icon}.png`)"/>
        </div>
      </div> -->

      <div class="langauge-selection__wrapper" @click="handleShowLanguageList('click')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18C7.77 18 6.6075 17.7636 5.5125 17.2908C4.4175 16.818 3.4611 16.173 2.6433 15.3558C1.8261 14.5386 1.1811 13.5825 0.708301 12.4875C0.235501 11.3925 -0.000598859 10.23 1.14068e-06 9C1.14068e-06 7.755 0.236401 6.5886 0.709201 5.5008C1.182 4.413 1.827 3.4608 2.6442 2.6442C3.4614 1.8264 4.4172 1.1814 5.5116 0.7092C6.606 0.237 7.7688 0.0006 9 0C10.245 0 11.4114 0.2364 12.4992 0.7092C13.587 1.182 14.5392 1.827 15.3558 2.6442C16.1736 3.4614 16.8186 4.4139 17.2908 5.5017C17.763 6.5895 17.9994 7.7556 18 9C18 10.23 17.7636 11.3925 17.2908 12.4875C16.818 13.5825 16.173 14.5389 15.3558 15.3567C14.5386 16.1739 13.5861 16.8189 12.4983 17.2917C11.4105 17.7645 10.2444 18.0006 9 18ZM9 16.155C9.39 15.615 9.7275 15.0525 10.0125 14.4675C10.2975 13.8825 10.53 13.26 10.71 12.6H7.29C7.47 13.26 7.7025 13.8825 7.9875 14.4675C8.2725 15.0525 8.61 15.615 9 16.155ZM6.66 15.795C6.39 15.3 6.1536 14.7861 5.9508 14.2533C5.748 13.7205 5.5794 13.1694 5.445 12.6H2.79C3.225 13.35 3.7689 14.0025 4.4217 14.5575C5.0745 15.1125 5.8206 15.525 6.66 15.795ZM11.34 15.795C12.18 15.525 12.9264 15.1125 13.5792 14.5575C14.232 14.0025 14.7756 13.35 15.21 12.6H12.555C12.42 13.17 12.2514 13.7214 12.0492 14.2542C11.847 14.787 11.6106 15.3006 11.34 15.795ZM2.025 10.8H5.085C5.04 10.5 5.0061 10.2036 4.9833 9.9108C4.9605 9.618 4.9494 9.3144 4.95 9C4.95 8.685 4.9614 8.3814 4.9842 8.0892C5.007 7.797 5.0406 7.5006 5.085 7.2H2.025C1.95 7.5 1.8936 7.7964 1.8558 8.0892C1.818 8.382 1.7994 8.6856 1.8 9C1.8 9.315 1.8189 9.6186 1.8567 9.9108C1.8945 10.203 1.9506 10.4994 2.025 10.8ZM6.885 10.8H11.115C11.16 10.5 11.1939 10.2036 11.2167 9.9108C11.2395 9.618 11.2506 9.3144 11.25 9C11.25 8.685 11.2386 8.3814 11.2158 8.0892C11.193 7.797 11.1594 7.5006 11.115 7.2H6.885C6.84 7.5 6.8061 7.7964 6.7833 8.0892C6.7605 8.382 6.7494 8.6856 6.75 9C6.75 9.315 6.7614 9.6186 6.7842 9.9108C6.807 10.203 6.8406 10.4994 6.885 10.8ZM12.915 10.8H15.975C16.05 10.5 16.1064 10.2036 16.1442 9.9108C16.182 9.618 16.2006 9.3144 16.2 9C16.2 8.685 16.1811 8.3814 16.1433 8.0892C16.1055 7.797 16.0494 7.5006 15.975 7.2H12.915C12.96 7.5 12.9939 7.7964 13.0167 8.0892C13.0395 8.382 13.0506 8.6856 13.05 9C13.05 9.315 13.0386 9.6186 13.0158 9.9108C12.993 10.203 12.9594 10.4994 12.915 10.8ZM12.555 5.4H15.21C14.775 4.65 14.2314 3.9975 13.5792 3.4425C12.927 2.8875 12.1806 2.475 11.34 2.205C11.61 2.7 11.8464 3.2139 12.0492 3.7467C12.252 4.2795 12.4206 4.8306 12.555 5.4ZM7.29 5.4H10.71C10.53 4.74 10.2975 4.1175 10.0125 3.5325C9.7275 2.9475 9.39 2.385 9 1.845C8.61 2.385 8.2725 2.9475 7.9875 3.5325C7.7025 4.1175 7.47 4.74 7.29 5.4ZM2.79 5.4H5.445C5.58 4.83 5.7489 4.2786 5.9517 3.7458C6.1545 3.213 6.3906 2.6994 6.66 2.205C5.82 2.475 5.0736 2.8875 4.4208 3.4425C3.768 3.9975 3.2244 4.65 2.79 5.4Z" fill="white"/>
        </svg>
        <div class="header-language__list-caret" :class="{ active: isShowLanguageList }">
          <svg class="down-arrow" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.73993 2.52026e-07L6.5345 4.58L11.3291 1.89288e-06L12.8019 1.41L6.5345 7.41L0.26709 1.41L1.73993 2.52026e-07Z" fill="white"/>
          </svg>
        </div>
      </div>

      <!-- countryBasedLangObjList -->
      <div class="language-list__wrapper" :class="{ selected: isShowLanguageList }">
        <div
          class="language-list__container"
          v-for="(o, index) in visitorLangList"
          :key="index"
          :class="{ selected: o.selected }"
          @click="handleLanguage(o)"
        >
          <div class="language-list__name">
            <!-- <img class="img-contain language-list__name-icon" :src="require(`../../static/images/flags/${o.icon}.png`)"/> -->
            <span>{{ o.displayName }}</span>
          </div>
          <div class="language-list__tick" :class="{ selected: o.selected }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal)
          this.setLangList();
      }
    },
  },
  computed: {
    ...mapGetters([
      "isMobile",
      "currentLocale",
      "currentLanguageList",
      "currentLanguageObj",
			"currentCountryObj",
      "currentCountryList",
      "brazilHeaderTabs",
    ]),
  },
  mounted() {
    this.setLangList();
    this.simpleHeader = this.isMobile ? this.brazilHeaderTabs : [this.brazilHeaderTabs[0]];
  },
  data() {
    return {
      simpleHeader: [],
      isShowLanguageList: false,
      visitorLangList: [],
    };
  },
  methods: {
    ...mapMutations([
      "UPDATE_USER_LANG_CONFIG",
    ]),
    ...mapActions([
      "currentCountryChangeEvent",
      "currentLocaleChangeEvent",
    ]),
    manualHighlightMenu(obj) {
      return this.isMatchTabsRoute() && obj.pathName == "brazilFootballMatches";
    },
    isMatchTabsRoute() {
      return ["FOOTBALL_INFO","FOOTBALL_FEED","FOOTBALL_LINEUPS","FOOTBALL_H2H","FOOTBALL_STATS","footballStatsAnalysis","footballStatsHandicap","footballStatsGoals","footballStatsWDL"].includes(this.$route.name);
    },
    async setLangList() {
			const user = localStorage.getItem("user");
			let countryCode;
			if (user === null) {// && !this.currentCountryObj
				// let result = await this.getCountryCodeByIp();
				countryCode = this.currentCountryObj.countryCode;//result.result.countryCode;
				if (true) {//result.message === "Success"
					this.currentCountryChangeEvent(countryCode);
				}
				let supportedLocaleList = this.currentCountryList.filter(x => x.countryCode === countryCode)[0]?.supportedLocale;
				this.visitorLangList = [];
				if (typeof supportedLocaleList === "undefined") {
					this.currentLanguageList.forEach(obj => {
						if (obj.displayLocale === "en") {
							obj.selected = true;
							this.visitorLangList.push(obj);
						}
					});
				} else {
					supportedLocaleList.forEach(locale => {
						this.currentLanguageList.forEach(obj => {
							if (obj.displayLocale === locale) {
								obj.selected = (obj.displayLocale === this.currentLocale) ? true : false;
								this.visitorLangList.push(obj);
							}
						});
					});
				}
			}
		},
    handleShowLanguageList(action) {
      if (action === "enter" && !this.isMobile) {
        //ingnore mobile touch event
        this.isShowLanguageList = true;
      } else if (action === "click") {
        this.isShowLanguageList = !this.isShowLanguageList;
      } else {
        this.isShowLanguageList = false;
      }
    },

    handleLanguage(o) {
      this.currentLocaleChangeEvent(o.displayLocale);

      this.UPDATE_USER_LANG_CONFIG(o.displayLocale);
    },
  },
}
</script>

<style scoped>
.simple-header-container {
  display: flex;
  justify-content: space-between;
  width: 996px;
  padding: 1.5rem 0;
  margin: 0 auto;
}
.language-wrapper {
  position: relative;
  z-index: 3;
}
.langauge-selection__wrapper {
  width: 3.5rem;
  display: flex;
  justify-content: flex-end;
	cursor: pointer;
}
.langauge-selection,
.mobile-default-avatar-wrapper {
  position: relative;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  padding: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-grey-60);
  cursor: pointer;
}
.langauge-selection:hover,
.mobile-default-avatar-wrapper:hover {
  background-color: var(--color-grey-40);
}
.language-list__wrapper {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.813rem;/*0.1rem;*/
  min-width: 12rem;
  background-color: var(--color-grey-60);
  padding: 0.5rem 0;/*0.5rem 0.3rem*/
  border-radius: 0.5rem;
  transform: scale(0);
  transform-origin: 11.5rem 0%;
  transition: all 0.3s;
}
.language-list__wrapper.selected {
  /* transform-origin: 11.5rem 0%; */
  transform: scale(1);
}
.language-list__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
	padding: 0.5rem;/*0.3rem 0.5rem*/
	margin-bottom: 0.375rem;
  cursor: pointer;
  transition: all 0.3s;
}
.language-list__container:last-child {
	margin-bottom: 0;
}
.language-list__container:hover,
.language-list__container.selected {
  background-color: var(--color-grey-40);
  border-radius: 0.4rem;
}
.language-list__name {
  display: flex;
  align-items: center;
  font-size: 0.88rem;
}
.language-list__name-icon {
  object-fit: contain;
  margin-right: 0.7rem;
  width: 1.5rem;
  height: 1.5rem;
}
.language-list__tick {
  width: 1rem;
  height: 1rem;
}
.language-list__tick.selected {
  background: url("../../../static/images/icons/icon_tick_selected.png")
    center/cover no-repeat;
}
.language-list__tick img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
/* header language selection */
.header-language__list-caret {
	margin-left: 0.5rem;
	display: flex;
	align-items: center;
	transition: all 0.3s;
}
.header-language__list-caret.active {
	transform: rotateX(180deg);
}

@media (max-width: 768px) {
  .simple-header-container {
    width: calc(100% - 1.2rem);
    padding: 1.5rem 0;
    margin: 0 0.6rem;
    position: fixed;
    background: var(--bg-theme);
    z-index: 3;
  }
}
</style>
